import {
  displayOrDash,
  formatDate,
  formatDateTime,
  getDaysInFlightLabel,
  getExpirationTone,
  getRetriesLabel,
  getTimeInStatusLabel,
} from '../utils';
import { ExpirationValue, SectionLabel, TimelineGrid, TimelineItem, TimelineLabel, TimelineValue } from './styled';
import type { TimelineProps } from './types';

const Timeline = ({ report }: TimelineProps) => {
  if (!report) return null;

  const expirationTone = getExpirationTone(report.expiration);
  const timeInStatusLabel = getTimeInStatusLabel(report.time_in_status);
  const retriesLabel = getRetriesLabel(report.retries);
  const hasEta = Boolean(report.eta?.trim());

  return (
    <section>
      <SectionLabel>Timeline</SectionLabel>
      <TimelineGrid>
        <TimelineItem>
          <TimelineLabel>Created</TimelineLabel>
          <TimelineValue>{formatDateTime(report.created_at)}</TimelineValue>
        </TimelineItem>

        <TimelineItem>
          <TimelineLabel>Last update</TimelineLabel>
          <TimelineValue>{report.updated_at ? formatDateTime(report.updated_at) : displayOrDash(null)}</TimelineValue>
        </TimelineItem>

        <TimelineItem>
          <TimelineLabel>Expiration</TimelineLabel>
          {report.expiration ? (
            <ExpirationValue tone={expirationTone}>{formatDateTime(report.expiration)}</ExpirationValue>
          ) : (
            <TimelineValue>{displayOrDash(null)}</TimelineValue>
          )}
        </TimelineItem>

        <TimelineItem>
          <TimelineLabel>Days in flight</TimelineLabel>
          <TimelineValue>{getDaysInFlightLabel(report.days_in_flight)}</TimelineValue>
        </TimelineItem>

        {hasEta && report.eta ? (
          <TimelineItem>
            <TimelineLabel>ETA</TimelineLabel>
            <TimelineValue>{formatDate(report.eta)}</TimelineValue>
          </TimelineItem>
        ) : null}

        {timeInStatusLabel ? (
          <TimelineItem>
            <TimelineLabel>Time in status</TimelineLabel>
            <TimelineValue>{timeInStatusLabel}</TimelineValue>
          </TimelineItem>
        ) : null}

        {retriesLabel ? (
          <TimelineItem>
            <TimelineLabel>Retries</TimelineLabel>
            <TimelineValue>{retriesLabel}</TimelineValue>
          </TimelineItem>
        ) : null}
      </TimelineGrid>
    </section>
  );
};

export default Timeline;
